// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Building2, Calendar, List } from "lucide-react";

const AvailabilityViewHeader = ({
  filterSummary,
  currentView,
  onViewChange,
  tenant,
  onTenantChange,
  tenantOptions = [],
  showTenantSelect = false,
}) => {
  return (
    <header className="av-header">
      <div>
        <div className="av-header-brand">
          <div className="av-header-accent" aria-hidden="true" />
          <h1>
            VHP Verfügbarkeit <em>— Belegte Tage</em>
          </h1>
        </div>
        <p className="av-header-sub">{filterSummary}</p>
      </div>

      <div className="av-header-actions">
        {showTenantSelect && (
          <div className="av-tenant-select-wrap">
            <Building2 size={14} aria-hidden className="av-tenant-icon" />
            <label htmlFor="av-filter-tenant" className="av-sr-only">
              Mandant (SuperAdmin)
            </label>
            <select
              id="av-filter-tenant"
              className="av-tenant-select"
              value={tenant}
              onChange={(e) => onTenantChange(e.target.value)}
              aria-label="Mandant auswählen"
            >
              {tenantOptions.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </div>
        )}

        <div
          className="av-view-toggle"
          role="group"
          aria-label="Ansicht wählen"
        >
          <button
            type="button"
            className={`av-toggle-btn${currentView === "calendar" ? " active" : ""}`}
            onClick={() => onViewChange("calendar")}
            aria-pressed={currentView === "calendar"}
          >
            <Calendar size={15} aria-hidden />
            Kalender
          </button>
          <button
            type="button"
            className={`av-toggle-btn${currentView === "list" ? " active" : ""}`}
            onClick={() => onViewChange("list")}
            aria-pressed={currentView === "list"}
          >
            <List size={15} aria-hidden />
            Liste
          </button>
        </div>
      </div>
    </header>
  );
};

export default AvailabilityViewHeader;
